import {
    Drawer,
    Portal,
    VStack,
    Grid,
    Input,
    Button,
    Text,
    Box,
    HStack,
    Flex,
} from "@chakra-ui/react";

import {
    useState,
    useEffect,
} from "react";

import AttachmentUpload from "../../../components/AttachmentUpload";
import MogomaDatePicker from "../../../components/MogomaDatePicker";

const AddDriverDocumentsDrawer = ({
    open,
    onClose,
    driver,
    onSubmit,
    loading = false,
}) => {
    const [
        form,
        setForm,
    ] = useState({
        license_number: "",
        license_expiry_date: "",
        route_preference:
            "Short Distance",
        package_preference:
            "Small",

        driver_license: [],
        criminal_record: [],
        identity_proof: [],
        police_affidavit: [],
        residential_address_proof: [],
        profile_image: [],
    });

    useEffect(() => {
        if (!open) {
            setForm({
                license_number: "",
                license_expiry_date: "",
                route_preference:
                    "Short Distance",
                package_preference:
                    "Small",

                driver_license: [],
                criminal_record: [],
                identity_proof: [],
                police_affidavit: [],
                residential_address_proof: [],
                profile_image: [],
            });
        }
    }, [open]);

    const handleSubmit = async () => {
        if (onSubmit) {
            await onSubmit(
                driver,
                form
            );
        }
    };

    const isFormComplete =
        form.license_number &&
        form.license_expiry_date &&
        form.route_preference &&
        form.package_preference &&
        form.driver_license.length > 0 &&
        form.criminal_record.length > 0 &&
        form.identity_proof.length > 0 &&
        form.police_affidavit.length > 0 &&
        form.residential_address_proof.length > 0 &&
        form.profile_image.length > 0;

    return (
        <Drawer.Root
            open={open}
            onOpenChange={(details) => {
                if (!details.open) {
                    onClose();
                }
            }}
            size="lg"
        >
            <Portal>
                <Drawer.Backdrop />

                <Drawer.Positioner>
                    <Drawer.Content>
                        <Drawer.Header
                            borderBottom="1px solid"
                            borderColor="gray.200"
                        >
                            <Flex
                                direction={{
                                    base: "column",
                                    md: "row",
                                }}
                                gap={3}
                                justify="space-between"
                                align={{
                                    base: "stretch",
                                    md: "center",
                                }}
                                width="100%"
                            >
                                <Box>
                                    <Drawer.Title>
                                        Add Driver Documents
                                    </Drawer.Title>

                                    <Text
                                        color="gray.500"
                                        fontSize="sm"
                                        mt={1}
                                    >
                                        Complete registration for{" "}
                                        {
                                            driver?.username
                                        }
                                    </Text>
                                </Box>

                                {/* Mobile actions */}
                                <HStack
                                    display={{
                                        base: "flex",
                                        md: "none",
                                    }}
                                    width="100%"
                                    gap={2}
                                >
                                    <Button
                                        variant="outline"
                                        flex={1}
                                        onClick={
                                            onClose
                                        }
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        bg="#2453FF"
                                        color="white"
                                        flex={1}
                                        disabled={
                                            !isFormComplete
                                        }
                                        loading={
                                            loading
                                        }
                                        onClick={
                                            handleSubmit
                                        }
                                        _hover={{
                                            bg: "#1D45D8",
                                        }}
                                    >
                                        Upload Documents
                                    </Button>
                                </HStack>
                            </Flex>
                        </Drawer.Header>

                        <Drawer.Body
                            py={6}
                        >
                            <VStack
                                gap={8}
                                align="stretch"
                            >
                                <Grid
                                    templateColumns={{
                                        base: "1fr",
                                        md: "repeat(2, 1fr)",
                                    }}
                                    gap={4}
                                >
                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            License Number
                                        </Text>

                                        <Input
                                            value={
                                                form.license_number
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        license_number:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                            placeholder="Enter license number"
                                            borderRadius="10px"
                                            height="45px"
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            License Expiry
                                        </Text>

                                        <MogomaDatePicker
                                            value={
                                                form.license_expiry_date
                                            }
                                            onChange={(
                                                value
                                            ) =>
                                                setForm(
                                                    prev => ({
                                                        ...prev,
                                                        license_expiry_date:
                                                            value,
                                                    })
                                                )
                                            }
                                            minDate={
                                                new Date()
                                                    .toISOString()
                                                    .split(
                                                        "T"
                                                    )[0]
                                            }
                                            placeholder="Select licence expiry date"
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Route Preference
                                        </Text>

                                        <select
                                            value={
                                                form.route_preference
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    prev => ({
                                                        ...prev,
                                                        route_preference:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                            style={{
                                                width:
                                                    "100%",
                                                padding:
                                                    "12px",
                                                borderRadius:
                                                    "10px",
                                                border:
                                                    "1px solid #E2E8F0",
                                                background:
                                                    "white",
                                            }}
                                        >
                                            <option value="">
                                                Select route preference
                                            </option>

                                            <option value="Short Distance">
                                                Short Distance
                                            </option>

                                            <option value="Long Distance">
                                                Long Distance
                                            </option>
                                        </select>
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Package Preference
                                        </Text>

                                        <select
                                            value={
                                                form.package_preference
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    prev => ({
                                                        ...prev,
                                                        package_preference:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                            style={{
                                                width:
                                                    "100%",
                                                padding:
                                                    "12px",
                                                borderRadius:
                                                    "10px",
                                                border:
                                                    "1px solid #E2E8F0",
                                                background:
                                                    "white",
                                            }}
                                        >
                                            <option value="">
                                                Select package preference
                                            </option>

                                            <option value="Small">
                                                Small
                                            </option>

                                            <option value="Medium">
                                                Medium
                                            </option>

                                            <option value="Large">
                                                Large
                                            </option>
                                        </select>
                                    </Box>
                                </Grid>

                                <AttachmentUpload
                                    title="Driver License"
                                    description="Upload Driver License"
                                    files={
                                        form.driver_license
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            prev => ({
                                                ...prev,
                                                driver_license:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                    accept=".pdf,image/*"
                                />

                                <AttachmentUpload
                                    title="Criminal Record"
                                    description="Upload Criminal Record"
                                    files={
                                        form.criminal_record
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            prev => ({
                                                ...prev,
                                                criminal_record:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                    accept=".pdf,image/*"
                                />

                                <AttachmentUpload
                                    title="Identity Proof"
                                    description="Upload Identity Proof"
                                    files={
                                        form.identity_proof
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            prev => ({
                                                ...prev,
                                                identity_proof:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                    accept=".pdf,image/*"
                                />

                                <AttachmentUpload
                                    title="Police Affidavit"
                                    description="Upload Police Affidavit"
                                    files={
                                        form.police_affidavit
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            prev => ({
                                                ...prev,
                                                police_affidavit:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                    accept=".pdf,image/*"
                                />

                                <AttachmentUpload
                                    title="Residential Address Proof"
                                    description="Upload Residential Address Proof"
                                    files={
                                        form.residential_address_proof
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            prev => ({
                                                ...prev,
                                                residential_address_proof:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                    accept=".pdf,image/*"
                                />

                              <Box pb={20}>
                            <AttachmentUpload
                                title="Profile Image"
                                description="Upload Profile Image"
                                files={form.profile_image}
                                onChange={(files) =>
                                    setForm(prev => ({
                                        ...prev,
                                        profile_image: files,
                                    }))
                                }
                                maxFiles={1}
                                accept="image/*"
                            />
                        </Box>
                            </VStack>
                        </Drawer.Body>

                        {/* Desktop actions */}
                        <Drawer.Footer
                            borderTop="1px solid"
                            borderColor="gray.200"
                            display={{
                                base: "none",
                                md: "block",
                            }}
                        >
                            <HStack
                                w="100%"
                                justify="flex-end"
                            >
                                <Button
                                    variant="outline"
                                    onClick={
                                        onClose
                                    }
                                >
                                    Cancel
                                </Button>

                                <Button
                                    bg="#2453FF"
                                    color="white"
                                    disabled={
                                        !isFormComplete
                                    }
                                    loading={
                                        loading
                                    }
                                    onClick={
                                        handleSubmit
                                    }
                                    _hover={{
                                        bg: "#1D45D8",
                                    }}
                                >
                                    Upload Documents
                                </Button>
                            </HStack>
                        </Drawer.Footer>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    );
};

export default AddDriverDocumentsDrawer;